import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '@app/_services';
import { environmentEmpleados } from '../../environments/environment.prod';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {
     }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        let currentUserComerciantes = this.authenticationService.currentUserValueComerciantes;
        //let currentUserEmpleados = this.authenticationService.currentUserValueEmpleados;  

        let currentUserEmpleados = JSON.parse(sessionStorage.getItem("currentUserEmpleados"))

        var subcadena = "PoliceProcedure/GetGroup";
        var subcadena2 = "PoliceProcedureDocument/GetByFilter2";
        if (request.url.toLowerCase().includes(subcadena.toLowerCase()) || request.url.toLowerCase().includes(subcadena2.toLowerCase())) {
            request = request.clone({
                setHeaders: {
                    'Content-Type':  'application/json',
                    Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaWQiOiJiY2E5M2JkMC02ZDJmLTRmMTgtYTdmNC03NzZhYjFhMzFiN2YiLCJzdWIiOiIyMzA3MzkiLCJ1c2VyX2lkIjoiMjMwNzM5IiwidXNlcm5hbWUiOiJ1c2VyUG9ydGFsV2ljIiwibmFtZSI6IlVzZXJQb3J0YWwiLCJmaXJzdF9sYXN0bmFtZSI6IldJQyIsInJvbGUiOiJVc2VyIiwicGljdHVyZSI6IiIsImV4cCI6MjAyMjE2NDcyNSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NDQzODUiLCJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjQyMDAifQ.AzeqhGjRmLsKXF0Di1OzhDwcrZMkCjmsxko6KFWayX4`
                }
            });
        } else{

            if (currentUser && currentUser.token) {
                request = request.clone({
                    setHeaders: {
                        'Content-Type':  'application/json',
                        Authorization: `Bearer ${currentUser.token}`
                    }
                });
            } else {
                if (currentUserComerciantes && currentUserComerciantes.token) {
                    request = request.clone({
                        setHeaders: {
                            'Content-Type':  'application/json',
                            Authorization: `Bearer ${currentUserComerciantes.token}`
                        }
                    });
                }else{  
                    if(currentUserEmpleados && currentUserEmpleados.token){
                        request = request.clone({
                            setHeaders: {
                                'Content-Type':  'application/json',
                                Authorization: `Bearer ${currentUserEmpleados.token}`
                            }
                        });
                    }else{           
                        let aux = request.url.split('/')[3]+'/'+request.url.split('/')[4]+'/'+request.url.split('/')[5]+'/'+request.url.split('/')[6];
                        console.log("aux",aux)
                        // if(aux == 'WicPortalEmpleadoAPI/api/Auth/Login'){
                        // if(aux.indexOf('Auth/Login')>-1){
                            // console.log(request.url.toLowerCase().trim());
                            // console.log(`${environmentEmpleados.apiUrl}/Auth/Login`.toLowerCase().trim());
                        if(request.url.toLowerCase().trim() == `${environmentEmpleados.apiUrl}/Auth/Login`.toLowerCase().trim()){
                            console.log("current login empleados")
                            request = request.clone({ 
                                withCredentials:true
                            });
                        }else{
                            request = request.clone({
                                setHeaders: {
                                    'Content-Type':  'application/json',
                                    Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaWQiOiJiY2E5M2JkMC02ZDJmLTRmMTgtYTdmNC03NzZhYjFhMzFiN2YiLCJzdWIiOiIyMzA3MzkiLCJ1c2VyX2lkIjoiMjMwNzM5IiwidXNlcm5hbWUiOiJ1c2VyUG9ydGFsV2ljIiwibmFtZSI6IlVzZXJQb3J0YWwiLCJmaXJzdF9sYXN0bmFtZSI6IldJQyIsInJvbGUiOiJVc2VyIiwicGljdHVyZSI6IiIsImV4cCI6MjAyMjE2NDcyNSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NDQzODUiLCJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjQyMDAifQ.AzeqhGjRmLsKXF0Di1OzhDwcrZMkCjmsxko6KFWayX4`
                                }
                            });
                        }
                    }
                }
            }

        }
       
        
        return next.handle(request);




    /*
        if(currentUserEmpleados && currentUserEmpleados.token){

            request = request.clone({
                setHeaders: {
                    'Content-Type':  'application/json',
                    //Authorization: `Bearer ${currentUserEmpleados.token}`
                    Authorization: `Bearer ${currentUserEmpleados.token}`
                }
            });
        }else{       
            let aux = request.url.split('/')[4]+'/'+request.url.split('/')[5]+'/'+request.url.split('/')[6];
            if(aux == 'api/Auth/Login'){
                console.log("if del aux")
                request = request.clone({ 
                    withCredentials:true
                });
            }else{
                request = request.clone({
                    setHeaders: {
                        'Content-Type':  'application/json',
                        Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiJVc2VySW5maW5pdHkiLCJyb2xlIjoiMSIsIm5iZiI6MTYwMzI4OTYyMSwiZXhwIjoxOTE4ODIyNDIxLCJpYXQiOjE2MDMyODk2MjF9.AE-i8hu0nLOcN4ogwg-2Fru6LuAp5zMa8VRr9IOxUTM`
                    }
                });
            }
        }
        */


    }
}

